import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
    image: {
        maxWidth: '90%',
        objectFit: 'cover',
        borderRadius: '20px',
        boxShadow: '0.5em 0.5em 1em'
    }
}));